<template>
  <div class="col-12">
    <div class="col-12" v-if="!resposta">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h4><i class="fas fa-history"></i> Histórico de Status</h4>
        <div>
          <button
            class="btn active btn-outline-secondary btn-sm"
            title="Voltar"
            @click="$emit('voltar')"
          >
            <i class="mdi mdi-arrow-left"></i>Voltar
          </button>
        </div>
      </div>
    </div>
    <div class="col-12" v-else>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h4><i class="mdi mdi-reply"></i> Resposta</h4>
      </div>
    </div>
    <load v-if="loading" mode="table" />
    <div v-else class="col-12 mb-3">
      <div class="row" v-if="!resposta">
        <div class="col-md-12">
          <table
            class="table table-bordered bg-white table-sm"
            v-for="historico in historicos"
            :key="historico.id"
          >
            <tr>
              <td class="bg-gray" colspan="2">
                O Status deste <b>Encaminhamento</b> foi atualizado de
                <b>{{ getStatusTitulo(historico.status_anterior) }}</b> para
                <b>{{ getStatusTitulo(historico.status_atual) }}</b>
              </td>
            </tr>
            <tr>
              <td>
                Técnico: <b>{{ historico.user_id }}</b>
              </td>
              <td>Data manual da ação:{{ historico.data_atualizacao }}</td>
            </tr>
            <tr>
              <td colspan="2" v-if="historico.motivo">
                Motivo: <b>{{ historico.motivo.descricao }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p><b>Descrição do Motivo</b></p>
                <span v-html="historico.observacoes"> </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-md-12" v-if="historicos && id != null">
          <table
            class="table table-bordered bg-white table-sm"
            v-for="historico in filterResposta"
            :key="historico.id"
          >
            <tr>
              <td>
                Técnico: <b>{{ historico.user_id }}</b>
              </td>
              <td>Data manual da ação:{{ historico.data_atualizacao }}</td>
            </tr>
            <tr>
              <td colspan="2" v-if="historico.motivo">
                Motivo: <b>{{ historico.motivo.descricao }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p><b>Descrição da Resposta</b></p>
                {{ historico.observacoes }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id", "familia", "status", "resposta"],
  data() {
    return {
      loading: true,
      historicos: {},
    };
  },
  computed: {
    filterResposta() {
      let tempRecipes = this.historicos;

      tempRecipes = tempRecipes.filter((item) => {
        return item.status_atual == 2;
      });

      return tempRecipes;
    },
  },
  mounted() {
    this.getHistorico();
    this.$root.$on("newhistorico", () => {
      this.getHistorico();
    });
  },
  methods: {
    getStatusTitulo(id) {
      if (this.status.length != undefined) {
        const result = this.status.filter((item) => item.id == id);
        return result[0] ? result[0].descricao : "";
      }
    },

    getHistorico() {
      this.loading = true;
      axios
        .get("api/dashboard/encaminhamentos/historico/status/" + this.id)
        .then((response) => {
          this.historicos = response.data;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(() => {
          swal.fire({
            title: "Ops!",
            html:
              "Histórico d Status não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
  },
};
</script>
